import _classCallCheck from "/codebuild/output/src2952102687/src/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2952102687/src/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src2952102687/src/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2952102687/src/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2952102687/src/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// src/index.tsx
import { Component } from "react";
import { connect } from "formik";
import scrollToElement from "scroll-to-element";
import flatten from "flat";
var ErrorFocus = /*#__PURE__*/function (_Component) {
  _inherits(ErrorFocus, _Component);
  var _super = _createSuper(ErrorFocus);
  function ErrorFocus() {
    var _this;
    _classCallCheck(this, ErrorFocus);
    _this = _super.apply(this, arguments);
    _this.timeout = null;
    return _this;
  }
  _createClass(ErrorFocus, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$formik = prevProps.formik,
        isSubmitting = _prevProps$formik.isSubmitting,
        isValidating = _prevProps$formik.isValidating,
        errors = _prevProps$formik.errors;
      var keys = Object.keys(flatten(errors));
      if (keys.length > 0 && isSubmitting && !isValidating) {
        var selector = "[data-error-key=\"".concat(keys[0], "\"]");
        var fallbackSelector = "[name=\"".concat(keys[0], "\"]");
        var errorElement = document.querySelector(selector) || document.querySelector(fallbackSelector);
        if (errorElement) {
          var _this$props = this.props,
            offset = _this$props.offset,
            ease = _this$props.ease,
            duration = _this$props.duration,
            focusDelay = _this$props.focusDelay,
            align = _this$props.align;
          scrollToElement(errorElement, {
            offset: offset,
            ease: ease,
            duration: duration,
            align: align
          });
          if (duration) {
            this.timeout = setTimeout(function () {
              return errorElement.focus();
            }, duration + focusDelay);
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return ErrorFocus;
}(Component);
ErrorFocus.defaultProps = {
  offset: 0,
  align: "top",
  focusDelay: 200,
  ease: "linear",
  duration: 1e3
};
var src_default = connect(ErrorFocus);
export { src_default as default };